export enum ProgramType {
  ESA = 'ESA+',
  OS = 'OS'
}
